import Vue from "vue";
import VueCookies from "vue-cookies";
import JWT from "jsonwebtoken";
import axios from "@/axios";
import { getTokenNames, getTokenStorage } from "./utils";

export const AdditionalFormsStore = {
    namespaced: true,

    state: {
        additionalFormData: null,
        decodedTokenData: null,
        validatedData: null,
        auth_tokens: {},
    },

    getters: {
        getAdditionalFormData: state => state.additionalFormData,
        getDecodedTokenData: (state) => state.decodedTokenData,
        getValidatedData: (state) => state.validatedData,
        getAuthTokens: (state) => state.auth_tokens,
    },

    mutations: {
        SET_ADDITIONAL_FORM_DATA(state, payload ) {
            state.additionalFormData = payload;
        },
        SET_VALIDATED_DATA(state, payload = null) {
            state.validatedData = payload
        },
        SET_DECODED_TOKEN_DATA(state, token = null) {
            state.decodedTokenData = token ? JWT.decode(token) : null;
        },
        SET_TOKEN_DATA(state, payload = {}) {
            const { type, value = null, cookies = true } = payload;
            if (type) {
                Vue.set(state.auth_tokens, type, value);
                if (cookies) {
                    VueCookies.set(type, value);
                }
            }
        }
    },

    actions: {
        async setLoginSession({ commit }, payload) {
            // set the session depending on the area the user is logging in
            const isAdditional = !!payload.additional;
            let authModule;
            if (isAdditional) authModule = "additional";
            const tokenNames = getTokenNames(authModule);
            const tokenStorage = getTokenStorage(authModule);

            commit("SET_TOKEN_DATA", {
                type: tokenNames.token,
                value: payload.token,
                cookies: tokenStorage.cookies,
            });
            commit("SET_TOKEN_DATA", {
                type: tokenNames.refresh_token,
                value: payload.refresh_token,
                cookies: tokenStorage.cookies,
            });
            commit("SET_DECODED_TOKEN_DATA", payload.token);
        },

        async validateIdentifier({ commit }, link_identifier) {
            try {
              const params = { link_identifier }
              const { data } = await axios.post('ext-auth/validate', params);
              console.log('validate', data);// TODO remove
              commit("SET_VALIDATED_DATA", data);
            } catch (error) {
              console.log(error?.message || `ERROR WHILE VALIDATING`);
              throw error
            }
          },
    }
};